import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { LoggingService } from '../services/logging.service';
import { AuthService } from '../auth.service';
import { FatalErrorService } from '../services/fatal-error.service';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private loggingService: LoggingService,
    private readonly authService: AuthService,
    private readonly fatal: FatalErrorService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          const status = error.status;

          const statusIndicatesFatal = status === 0;
          const urlLower = (req.url || '').toLowerCase();
          const isBootCriticalEndpoint = [
            'openid-configuration', // OIDC discovery
            'certs',                // OIDC certs 
            'profile',              // User profile
            'fetchinfrastructure'   // Infrastructure 
          ].some((endpoint) => urlLower.includes(endpoint));

          // Do not double-handle explicit 403 or 401 on /profile; JwtInterceptor handles access denied
          const isExplicitAccessDeniedOnProfile = status === 403 || status === 401 && urlLower.includes('/profile');
          const isKeyCloakError = urlLower.includes('keyc');

          const isFatal = statusIndicatesFatal || (isBootCriticalEndpoint && !isExplicitAccessDeniedOnProfile);
          if (isFatal) {
            const logInformation = {
              endpoint: req.url,
              method: req.method,
              status: String(status),
              message: error.message,
              userClaims: this.authService.claims,
              timestamp: new Date().toISOString(),
            } as { [key: string]: any };

            if (error.error) {
              logInformation['errorBody'] = typeof error.error === 'string' ? error.error : JSON.stringify(error.error);
            }

            this.loggingService.logTrace('Fatal HTTP error intercepted', logInformation);
            this.loggingService.logException(error);

            try {
              this.fatal.setFatal(true);
              this.fatal.setDetails({ status, isKeyCloakError });
              this.router.navigate(['/error'], { replaceUrl: true });
            } catch (e) {}
          }
        }
        return throwError(() => error);
      })
    );
  }
}


